import {PUBLISH_ROUTE_ROLE_APPLICATION} from "~/contants/base";

export default function({ app, error, store, route }) {

  const isRoleApplication = store.state.frontend.auth.user.is_role_application
  let currentPath = route.name

  if (isRoleApplication && !PUBLISH_ROUTE_ROLE_APPLICATION.some(path => currentPath === path)) {
    return error({
      message: '権限がありません。',
      redirectPath: app.$redirectPathDefault(),
      redirectText: 'メインメニュー',
    })
  }
}
